<template>
    <v-content>
      <section id="hero">
        <v-row no-gutters>
          <v-carousel>
            <v-carousel-item
              v-for="(item,i) in items"
              :key="i"
              :src="item.src"
              reverse-transition="fade-transition"
              transition="fade-transition">
            <v-theme-provider dark>
              <v-container fill-height>
                <v-row
                  align="center"
                  class="white--text mx-auto"
                  justify="center"
                >
                  <v-col
                    class="white--text text-center"
                    cols="12"
                    tag="h1"
                  >
                    <span
                    :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                      class="font-weight-light"
                    >
                      WELCOME TO
                    </span>

                    <br>

                    <span
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
                      class="font-weight-black"
                    >
                      A.ROWE
                    </span>

                    <br>

                  </v-col>

                  <v-btn
                    class="align-self-end"
                    fab
                    outlined
                    @click="$vuetify.goTo('#about-me')"
                  >
                    <v-icon>mdi-chevron-double-down</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-theme-provider>
          <!-- </v-img> -->
            </v-carousel-item>
          </v-carousel>
        </v-row>
      </section>

      <section id="about-me">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">ABOUT ME</h2>

          <v-responsive
            class="mx-auto mb-8"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >
            freelance web engineer, design a.rowe.
            <br>
            Activities based in Fukuoka Kasuya city.
            
          </v-responsive>

          <v-avatar
            class="elevation-12 mb-12"
            size="128"
          >
            <v-img src="../assets/owner_arowe.jpg"></v-img>
          </v-avatar>

          <div></div>

          a.rowe

          <v-responsive
            class="mx-auto mb-8"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section
        id="features"
        class="grey lighten-3"
      >
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3"></h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ icon, title, text }, i) in features"
              :key="i"
              cols="12"
              md="6"
            >
              <v-card
                class="py-12 px-4"
                color="grey lighten-5"
                flat
              >
                <v-theme-provider dark>
                  <div>
                    <v-avatar
                      color="primary"
                      size="88"
                    >
                      <v-icon
                        large
                        v-text="icon"
                      ></v-icon>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-text="title"
                ></v-card-title>

                <v-card-text
                  class="subtitle-1"
                  v-text="text"
                >
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="stats">
        <v-parallax
          :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
          src="../assets/code_display1950.jpg"
        >
          <v-container fill-height>
            <v-row class="mx-auto">
              <v-col
                v-for="[value, title] of stats"
                :key="title"
                cols="12"
                md="3"
              >
                <div class="text-center">
                  <div
                    class="display-3 font-weight-black mb-4"
                    v-text="value"
                  ></div>

                  <div
                    class="title font-weight-regular text-uppercase"
                    v-text="title"
                  ></div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </section>

      <section id="blog">
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Blog</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ src, text, title, url }, i) in articles"
              :key="i"
              cols="12"
              md="4"
            >
              <a v-bind:href="url">
                <v-img
                  :src="src"
                  class="mb-4"
                  height="275"
                  max-width="100%"
                ></v-img>
              </a>

              <h3
                class="font-weight-black mb-4 text-uppercase"
                v-text="title"
              ></h3>

              <div
                class="title font-weight-light mb-5"
                v-text="text"
              ></div>

              <v-btn
                class="ml-n4 font-weight-black"
                text
                :href="url"
              >
                Access site.
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <v-form ref="form" v-model="contactFormValidation.valid" lazy-validation>
      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Contact Me</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-theme-provider light>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="contactForm.name"
                  :rules="contactFormValidation.nameRules"
                  label="名前"
                  required
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="contactForm.email"
                  :rules="contactFormValidation.emailRules"
                  label="メールアドレス"
                  required
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="contactForm.subject"
                  :rules="contactFormValidation.subjectRules"
                  label="件名"
                  required
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="contactForm.message"
                  :rules="contactFormValidation.messageRules"
                  label="内容"
                  required
                  solo
                ></v-textarea>
              </v-col>

              <!-- <v-col
                class="mx-auto"
                cols="auto"
              >
                <v-btn
                  :loading="contactForm.loading"
                  :disabled="!contactFormValidation.valid"
                  @click="sendMail()"
                  block
                  large
                  color="info"
                  class="mt-4 ma-2 font-weight-bold"
                >{{ submit }}
                </v-btn>
              </v-col> -->
            </v-row>
          </v-theme-provider>
          <div class="text-center">
            <v-btn
              :loading="contactForm.loading"
              :disabled="!contactFormValidation.valid"
              @click="sendMail()"
              class="mt-4 ma-2 font-weight-bold"
              color="info"
              large
              >{{ submit }}</v-btn>
            <v-btn
              @click="formReset()" 
              class="mt-4 ma-2 font-weight-bold" 
              color="Normal"
              outlined 
              large
              >{{ reset }}</v-btn>
          </div>
        </v-container>
        <v-snackbar
          v-model="snackBar.show"
          :color="snackBar.color"
          bottom
          right
          :timeout="6000"
          class="font-weight-bold"
        >
        {{snackBar.message}}
        </v-snackbar>
        <div class="py-12"></div>
      </v-sheet>
      </v-form>
    </v-content>
</template>

<script>
import { functions } from '@/plugins/firebase'

export default {
  name: "PortFolio",

  data: () => ({
    submit: "送信",
    reset: "クリア",    
    items: [
          {
            src: 'https://arowe-portfolio.netlify.app/img/top_carousel_01.acab8090.jpg',
          },
           {
            src: 'https://arowe-portfolio.netlify.app/img/top_carousel_02.567d73ce.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
          },
        ],
      contactForm: {
        name: '',
        subject: '',
        message: '',
        email: '',
        loading: false
      },
      contactFormValidation: {
        valid: false,
        nameRules: [v => !!v || '名前は必須項目です'],
        emailRules: [v => !!v || 'メールアドレスは必須項目です'],
        subjectRules: [v => !!v || '件名は必須項目です'],
        messageRules: [v => !!v || '内容は必須項目です']
      },
      snackBar: {
        show: false,
        color: '',
        message: ''
      },
    ecosystem: [
      {
        text: "vuetify-loader",
        href: "https://github.com/vuetifyjs/vuetify-loader"
      },
      {
        text: "github",
        href: "https://github.com/vuetifyjs/vuetify"
      },
      {
        text: "awesome-vuetify",
        href: "https://github.com/vuetifyjs/awesome-vuetify"
      }
    ],
    importantLinks: [
      {
        text: "Documentation",
        href: "https://vuetifyjs.com"
      },
      {
        text: "Chat",
        href: "https://community.vuetifyjs.com"
      },
      {
        text: "Made with Vuetify",
        href: "https://madewithvuejs.com/vuetify"
      },
      {
        text: "Twitter",
        href: "https://twitter.com/vuetifyjs"
      },
      {
        text: "Articles",
        href: "https://medium.com/vuetify"
      }
    ],
    whatsNext: [
      {
        text: "Explore components",
        href: "https://vuetifyjs.com/components/api-explorer"
      },
      {
        text: "Select a layout",
        href: "https://vuetifyjs.com/layout/pre-defined"
      },
      {
        text: "Frequently Asked Questions",
        href: "https://vuetifyjs.com/getting-started/frequently-asked-questions"
      }
    ],
    articles: [
      {
        src: 'https://arowe-portfolio.netlify.app/img/blog_top.7dd11b6f.jpg',
        title: 'hatena Blog for えーどっとアール.com',
        text: 'はてなブログよりえーどっとアール.comから不定期に発信します。',
        url: "https://arowe.hatenablog.com/",
      },
      {
        src: 'https://arowe-portfolio.netlify.app/img/blog_review_top.be38c62e.jpg',
        title: 'hatena Blog for 商品レビュー',
        text: 'Amazonや楽天で購入した商品レビューを不定期に発信します。辛口な評価やベタ褒めする商品をつらつらと紹介します。',
        url: "https://arowe-review.hatenablog.com/",
      },
      {
        src: 'https://arowe-portfolio.netlify.app/img/blog_study_top.5bcd25d8.jpg',
        title: 'hatena Blog for arowe-studyブログ',
        text: '主にWEB中心のプログラミング言語やUIデザインなどの調べものや備忘録を書き残しています。自身のメモ用に利用しています。',
        url: "https://arowe-study.hatenablog.com/",
      },
    ],
    features: [
      {
        icon: 'mdi-settings-outline',
        title: 'Development Records',
        text: 'WEB DEVELOPMENT 85%  OTHER 15%',
      },
      {
        icon: 'mdi-pencil-outline',
        title: 'Skills',
        text: 'Access Ajax Apache ASP.NET C# CSS Firebase Git GO HTML Java JavaScript MySQL Lambda Nginx Nuxt.js Oracle PHP PostgreSQL SCSS SQL Server Vue.js WordPress',
      },
    ],
    stats: [
      ['3+α/1', 'Win/Mac'],
      ['4+α/1', 'Android/iOs'],
      ['22', 'projects'],
      ['13', 'Total experienced'],
    ],
  }),
  methods: {
      sendMail: function () {
        if (this.$refs.form.validate()) {
          this.contactForm.loading = true
          const mailer = functions.httpsCallable('sendMail')

          mailer(this.contactForm)
            .then(() => {
              this.formReset()
              this.showSnackBar(
                'success',
                'お問い合わせありがとうございます。送信完了しました'
              )
            })
            .catch(err => {
              this.showSnackBar(
                'error',
                '送信に失敗しました。時間をおいて再度お試しください'
              )
              console.log(err)
            })
            .finally(() => {
              this.contactForm.loading = false
            })
        }
      },
      showSnackBar: function (color, message) {
        this.snackBar.message = message
        this.snackBar.color = color
        this.snackBar.show = true
      },
      formReset: function () {
        this.$refs.form.reset()
      }
    }
};
</script>
